import { render, staticRenderFns } from "./ItemNumber.vue?vue&type=template&id=60838e94&scoped=true&"
import script from "./ItemNumber.vue?vue&type=script&lang=ts&"
export * from "./ItemNumber.vue?vue&type=script&lang=ts&"
import style0 from "./ItemNumber.vue?vue&type=style&index=0&id=60838e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60838e94",
  null
  
)

export default component.exports